<template>
  <div
    style="background-color: black; color: white; display:flex;justify-content:center;align-items:center;"
  >
    <div>Error: {{ message }}</div>
  </div>
</template>
<script>
export default {
  props: {
    message: { type: String, required: true }
  }
}
</script>
<style scoped></style>
